import FocusManage from './index';
import PlateManage from './plateManage';
import PlatePair from './platePair';

export default {
    path: '/home/focus',
    component: FocusManage,
    children: [
        {path: '/home/focus/plateManage', component: PlateManage},
        {path: '/home/focus/PlatePair', component: PlatePair}
    ]
};
